<template>
  <div class="goods_add">

    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="属性名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>

      <el-form-item label="标签名标" prop="cate">
        <el-select v-model="ruleForm.cate" placeholder="请选择所属标签">
          <el-option
            :label="item.name"
            :value="item.name + '_' + item.id"
            :key="index"
            v-for="(item, index) in attr_name.data"
          ></el-option>
        </el-select>
      </el-form-item>

      <div class="mt-20"></div>

      <el-form-item class="quill-editor-top">
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button @click="resetForm('ruleForm')" ref="ruleForm">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="attr_name.data" border style="width: 100%" :show-header="false">
      <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
      <el-table-column label="">
        <template slot-scope="scope">
          <el-table
            :data="scope.row.attr"
            border
            style="width: 100%"
            :show-header="false"
          >
            <el-table-column prop="name">
              <template slot-scope="scope1">
                <div>{{ scope1.row.name }}</div>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope1">
                <el-button
                  @click.native="edit(scope1.row, scope.row)"
                  type="primary"
                  size="small"
                  >编辑</el-button
                >
                  <el-button
                          @click.native="delete_attr(scope1.row)"
                          type="primary"
                          size="small"
                  >删除</el-button
                  >

              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
    </el-table>
    
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"

    >
      <span>
        <el-input v-model="attr_cate_name" placeholder="请输入内容"></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="edit_save()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        name: "",

        cate: "",
      },
      dialogVisible: false,
      attr_cate_name: "",
      attr_cate_name_id: "",
      attr_id: "",
      rules: {
        name: [
          {
            required: true,
            message: "请输入属性名称",
            trigger: "blur",
          },
        ],

        cate: [
          {
            required: true,
            message: "请选择所属标签",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      attr_name: (state) => state.attr_name.result,
      attr: (state) => state.attr.result,
    }),
  },
  methods: {
    ...mapActions({
      getAttrNameDataAction: "getAttrNameDataAction",
      addAttrDataAction: "addAttrDataAction",
      editAttrDataAction: "editAttrDataAction",
      deleteAttrAction:"deleteAttrAction",
    }),
    edit(attr_name, attr) {
      this.dialogVisible = true;
      this.attr_cate_name = attr_name.name;
      this.attr_cate_name_id = attr_name.id;

      this.attr_id = attr.id;

      console.log(attr_name, attr);
    },
    delete_attr(attr_name) {


          this.attr_cate_name_id = attr_name.id;

        this.deleteAttrAction({"id":this.attr_cate_name_id })





      },

    edit_save() {
      this.dialogVisible = false;
      this.editAttrDataAction({
        attr_cate_name: this.attr_cate_name,
        attr_cate_name_id: this.attr_cate_name_id,
        attr_id: this.attr_id,
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveData();
        } else {
          this.$message("请输入正确信息");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    saveData() {
      this.addAttrDataAction({ name: this.ruleForm.name, cate: this.ruleForm.cate });
    },
  },
  created() {
    this.getAttrNameDataAction({});
  },
  watch: {
    attr(newdata) {
      if (newdata.code == 400) {
        this.$message("属性已经存在");
      }
      if (newdata.code == 200) {
        this.$refs["ruleForm"].resetFields();
        this.getAttrNameDataAction({});
      }
      if (newdata.code == 301) {
        this.$message("属性更新成功");
        this.getAttrNameDataAction({});
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.quill-editor {
  height: 400px;
}

.quill-editor-bottom {
  margin-bottom: 20px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #260a0a;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.el-upload-list--picture-card .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 90px !important;
}

.title_bg {
  background-color: #f5fffa;
  padding: 10px;
}

.el-form-item__content {
  margin-left: 30px;
}
</style>
